import { SHIRT_SIZES } from '../../../lib/types';
import { TShirtIcon } from '../../../components/TShirtIcon';
import { SHIRT_SHORT } from '../lib';
import type { ShirtSize } from '../../../lib/types';

interface ShirtSizePickerProps {
  value: ShirtSize | null;
  onChange: (size: ShirtSize) => void;
}

export function ShirtSizePicker({ value, onChange }: ShirtSizePickerProps) {
  return (
    <fieldset>
      <legend>Select your shirt size</legend>
      <div className="smash-shirt-grid">
        {SHIRT_SIZES.map((s) => (
          <label key={s} className="smash-shirt-option">
            <input
              type="radio"
              name="shirt_size"
              value={s}
              checked={value === s}
              onChange={() => onChange(s)}
            />
            <TShirtIcon className="smash-shirt-option__icon" />
            <span className="smash-shirt-option__label">{SHIRT_SHORT[s]}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
